const careersData = [
    {
      title: "REACT Native-DEVELOPER",
      jobexp: "1-2 years",
      location: "Hyderbad",
      description:
        "We are looking for a React Native developer. Primary focus will be on developing user interface components following well-known React.js workflows (such as Flux or Redux).",
      link: "/",
    },
    {
      title: ".Net Developer",
      jobexp: "1-2 years",
      location: "Hyderabad",
      description:"We are looking for a .NET developer.Primary focus will be on developing Rest APIS and implementing them.",
      link: "/",
    },
    {
      title: "Python Developer",
      jobexp: "3-4 years",
      location: "Banglore",
      image: "./hotels.svg",
      description:"We are looking for a Python developer. Primary focus in Django framework and Web Scraping.You will coordinate with the rest of the team working on different layers of the infrastructure.",      link: "/",
    },
    {
        title: "UI/UXDeveloper",
        jobexp: "0-1 years",
        location: "Banglore",
        image: "./hotels.svg",
        description:"We are looking for a UI/UX developer. Primary focus is to Design the prototypes with Figma and Adobe xd You will coordinate with the rest of the team working on different layers of the infrastructure.",      link: "/",
      },
      {
        title: "Full stack Developer",
        jobexp: "5-7 years",
        location: "Mumbai",
        image: "./hotels.svg",
        description:"We are looking for a Full stack developer. Primary focus is to Design the REST Api's using Java with SpringBoot. You will coordinate with the rest of the team working on different layers of the infrastructure.",      link: "/",
      },
      {
        title: "Frontend-Developer",
        jobexp: "5-7 years",
        location: "Pune",
        image: "./hotels.svg",
        description:"We are looking for a Front-end developer. Primary focus is to Design the Web application using Nextjs with Redux.",      link: "/",
      },
  ];
  
  export default careersData;